import { Store } from 'vuex';
import { UpdateWSEventStatePayload, WebSocketState } from '@/store/modules/websocket/websocket.types';

export const webSocketActions = {
    wsConnect(store: Store<WebSocketState>) {
        store.commit('WS_CONNECTION_STATUS_MUTATION', true);
    },
    wsDisconnect(store: Store<WebSocketState>) {
        store.commit('WS_CONNECTION_STATUS_MUTATION', false);
    },
    wsUpdateEvent(store: Store<WebSocketState>, payload: UpdateWSEventStatePayload) {
        store.commit('WS_UPDATE_EVENT_MUTATION', payload);
    },
    wsReconnect(store: Store<WebSocketState>) {
        store.commit('WS_RECONNECTED_MUTATION');
    }
}